const getCentsFromDollars = (value) => value && Math.round(value * 100);

export default getCentsFromDollars;
